import { render, staticRenderFns } from "./ShippingBannerSection.vue?vue&type=template&id=6e4f7d2b&scoped=true&"
import script from "./ShippingBannerSection.vue?vue&type=script&lang=js&"
export * from "./ShippingBannerSection.vue?vue&type=script&lang=js&"
import style0 from "./ShippingBannerSection.vue?vue&type=style&index=0&id=6e4f7d2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f7d2b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
